export const engineStateKeyFactory = {
  all: ['engineState'] as const,
}
